import { render, staticRenderFns } from "./DonutChart11.vue?vue&type=template&id=2c45e68b&scoped=true"
import script from "./DonutChart11.vue?vue&type=script&lang=js"
export * from "./DonutChart11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45e68b",
  null
  
)

export default component.exports